import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBox from "../../AdminComponents/Common/SearchBox";
import PaginationDataTable from "../../AdminComponents/Common/PaginationDataTable";
import { analyticsData, Months, years } from "../../Services/dymmyData";
import { useNavigate } from "react-router-dom";
import Heading from "../../AdminComponents/Common/Heading";
import CustomButton from "../../Components/Common/CustomButton";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { theme } from "../../Assets/Theme/theme";

function Analytics() {
  const navigate = useNavigate();
  const [analyticData, setAnalyticsData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [loading, setLoading] = useState(false);
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  const columns = [
    { id: "S.no", name: "S.no" },
    { id: "experienceName", name: "Experience" },
    { id: "totalBookings", name: "Bookings" },
    { id: "totalRevenue", name: "Total Revenue" },
  ];

  const fetchAnalyticsData = async () => {
    const formattedMonth = selectedValue.padStart(2, "0");
    if (!selectedYear || !selectedValue) {
      toast.warn("Please select both year and month to filter data.", {
        position: "top-right",
      });
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/analytics/filter`,
        { year: selectedYear, month: formattedMonth },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setAnalyticsData(response?.data?.data || []);
    } catch (error) {
      console.error(
        "Error fetching filtered analytics data:",
        error?.response?.data
      );
      setAnalyticsData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/admin/analytics`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const sortedData = (response?.data?.data || []).sort(
        (a, b) => b.totalBookings - a.totalBookings
      );

      setAnalyticsData(sortedData);
    } catch (error) {
      if (error.response?.status === 401 || error.message.includes("Authentication")) {
        navigate("/login");
      } else {
        toast.error("Error fetching all data", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    if (selectedYear && selectedValue) {
      fetchAnalyticsData();
    }
  }, [selectedYear, selectedValue]);

  const handleReset = () => {
    setSelectedValue("");
    setSelectedYear("");
    fetchAllData();
  };

  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Box>
      <Heading label={"Analytics Reports"} />
      <Box
        mt={4}
        display={"flex"}
        justifyContent={"flex-end"}
        flexWrap={"wrap"}
        gap={3}
        alignItems={"center"}
      >
        {/* <Box width={{ xs: "100%", md: "fit-content" }} mb={2} sx={{}}>
          <CustomButton outline height="43px" fontSize="16px" borderWidth="1px">
            Popularity
          </CustomButton>
        </Box> */}
        <Box width={{ xs: "100%", md: 200 }}>
          <Dropdown
            padding={"14px"}
            options={Months}
            value={selectedValue}
            placeholder="Select Month"
            onChange={(e) => setSelectedValue(e.target.value)}
            bgColor="#EEEEEE"
            border
          />
        </Box>
        <Box width={{ xs: "100%", md: 150 }}>
          <Dropdown
            padding={"14px"}
            options={years}
            value={selectedYear}
            placeholder="Select Year"
            onChange={(e) => setSelectedYear(e.target.value)}
            bgColor="#EEEEEE"
            height="250px"
            border
          />
        </Box>
        <Box mb={2}>
          <CustomButton
            onClick={handleReset}
            bgColor="#FF6F61"
            color="#FFFFFF"
            height="43px"
            fontSize="16px"
          >
            Reset
          </CustomButton>
        </Box>
      </Box>

      <Box mt={4}>
        {loading ? (
          <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", 
          }}
        >
          <CircularProgress size={30} sx={{ color: theme.colors.orange }} />
        </Box>
        ) :  (
          <PaginationDataTable
            editAndDelete={true}
            columns={columns}
            rows={analyticData}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Box>
    </Box>
  );
}

export default Analytics;
